import { createColumnHelper, type ColumnDef } from "@tanstack/react-table";
import type { Job } from "../../interfaces/apiInterfaces/jobs";
import JobDetailsButton from "./JobDetailsButton";
import { renderJobStatus, renderGraphicsStatus, formatDateTime } from "./TableUtils";

const columnHelper = createColumnHelper<Job>();

export const createTableColumns = (): ColumnDef<Job, any>[] => [
  columnHelper.accessor("job_id", {
    header: "Job ID",
    cell: (info) => <span className="job-id">{info.getValue()}</span>,
    size: 160,
    enableSorting: true,
  }),
  columnHelper.accessor("user_email", {
    header: "User Email",
    cell: (info) => <span className="text-strong">{info.getValue()}</span>,
    size: 220,
  }),
  columnHelper.accessor("file_name", {
    header: "File Name",
    cell: (info) => <span className="text-strong">{info.getValue()}</span>,
    size: 220,
  }),
  columnHelper.accessor("subject_title", {
    header: "Subject",
    cell: (info) => <span className="text-strong">{info.getValue()}</span>,
    size: 180,
  }),
  columnHelper.accessor("job_created_at_utc", {
    header: "Upload Date and Time",
    cell: (info) => <span className="text-strong">{formatDateTime(info.getValue())}</span>,
    size: 220,
    enableSorting: true,
  }),
    columnHelper.accessor("job_updated_at_utc", {
    header: "Update Date and Time",
    cell: (info) => <span className="text-strong">{formatDateTime(info.getValue())}</span>,
    size: 220,
    enableSorting: true,
  }),
  columnHelper.accessor("job_status_count", {
    header: "Uploading Status",
    cell: (info) => renderJobStatus(info.row.original.job_status, info.getValue()),
    size: 250,
    enableSorting: false,
  }),
  columnHelper.accessor("job_graphics_status_count", {
    header: "Graphics Status",
    cell: (info) => renderGraphicsStatus(info.row.original.job_status, info.getValue()),
    size: 220,
    enableSorting: false,
  }),
  columnHelper.accessor((row) => row.job_status_count?.published_count ?? 0, {
    id: "published_count",
    header: "Published Questions",
    cell: (info) => <span className="text-strong">{info.getValue()}</span>,
    size: 220,
    enableSorting: false,
  }),
  columnHelper.display({
    id: "jobDetails",
    header: "",
    cell: (info) => {
      return <JobDetailsButton jobId={info.row.original.job_id} jobStatus={info.row.original.job_status} jobType={info.row.original.job_type} />;
    },
    size: 160,
    enableSorting: false,
  }),
];
